import * as React from 'react';
import * as ReactDOM from 'react-dom';
import ContextualCallout from './ContextualCallout';
import IFrameableDialog from './IFrameableDialog';
import TaskPaneCollection from './TaskPaneCollection';
import UILessAddinCommandsComponent from './UILessAddinCommandsComponent';
import { SsoDialogWrapper } from 'owa-addins-sso';

let frameworkComponent: HTMLDivElement;
export function lazyInitializeExtensibilityFrameworkComponent(
    renderTaskPaneInPanel: boolean
): void {
    if (frameworkComponent) {
        return;
    }

    frameworkComponent = document.createElement('div');
    document.body.appendChild(frameworkComponent);
    ReactDOM.render(
        <ExtensibilityFrameworkComponent renderTaskPaneInPanel={renderTaskPaneInPanel} />,
        frameworkComponent
    );
}

export function removeExtensibilityFrameworkComponent(): void {
    if (frameworkComponent == null) {
        return;
    }

    ReactDOM.unmountComponentAtNode(frameworkComponent);
    document.body.removeChild(frameworkComponent);
}

export interface ExtensibilityFrameworkComponentProps {
    renderTaskPaneInPanel: boolean;
}

export class ExtensibilityFrameworkComponent extends React.Component<
    ExtensibilityFrameworkComponentProps,
    {}
> {
    render(): JSX.Element {
        return (
            <div>
                {this.props.renderTaskPaneInPanel && (
                    <TaskPaneCollection renderTaskPaneInPanel={true} />
                )}
                <UILessAddinCommandsComponent />
                <ContextualCallout />
                <IFrameableDialog />
                <SsoDialogWrapper />
            </div>
        );
    }
}
